import React, { useState, useEffect } from "react";
import { FaArrowUp, FaPhone, FaWhatsapp } from "react-icons/fa";
import "./scroll.css";

const Scroll = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* CALL + WHATSAPP Group */}
      <div className="floating-buttons">
        <a href="tel:+919035289171" className="floating-btn call-btn">
          <FaPhone />
        </a>

        <a
          href="https://wa.me/+919035289171"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn whatsapp-btn"
        >
          <FaWhatsapp />
        </a>

        {/* Scroll to Top Button */}
        {isVisible && (
          <button
            className="floating-btn scroll-top-btn"
            onClick={scrollToTop}
          >
            <FaArrowUp />
          </button>
        )}
      </div>
    </>
  );
};

export default Scroll;
